import React, { useState } from "react";
import { FaEye, FaPaperPlane, FaCode } from "react-icons/fa";
import TypingAnimation from "./TypingAnimation";

const Hero = () => {
  const [typingTexts] = useState(["Full Stack Developer", "UI/UX Designer"]);

  return (
    <section className="hero" id="home">
      <div className="container">
        <div className="hero-content">
          <h4 className="greeting">Hello, I'm</h4>
          <h1 className="hero-title">
            Nirmal <span className="highlight">Dhakal</span>
          </h1>
          <h2 className="hero-subtitle">
            <TypingAnimation texts={typingTexts} />
            <span className="cursor">|</span>
          </h2>
          <p className="hero-description">
            I craft digital experiences that are beautiful, functional, and
            user-friendly. Passionate about clean code, innovative design, and
            solving real-world problems.
          </p>
          <div className="hero-buttons">
            <a href="#projects" className="btn btn-primary pulse-animation">
              <FaEye /> View My Work
            </a>
            <a href="#contact" className="btn btn-secondary">
              <FaPaperPlane /> Contact Me
            </a>
          </div>
          <div className="hero-stats">
            <div className="stat">
              <h3>8+</h3>
              <p>Projects</p>
            </div>
            <div className="stat">
              <h3>15+</h3>
              <p>Happy Clients</p>
            </div>
            <div className="stat">
              <h3>2+</h3>
              <p>Years Experience</p>
            </div>
          </div>
        </div>
        <div className="hero-image">
          <div className="image-wrapper">
            <div className="floating-shapes">
              <div className="shape shape-1"></div>
              <div className="shape shape-2"></div>
              <div className="shape shape-3"></div>
            </div>
            <div className="profile-container">
              <img
                src="https://cdn.dribbble.com/userupload/46115090/file/a470de6b21e6ba729e63456dd385ba8c.jpg?resize=1504x2256&vertical=center"
                alt="Nirmal Dhakal"
                className="profile-img"
              />
              <div className="profile-badge">
                <FaCode />
                <span>Available for Work</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
